import AuthorizationApi from "../../service/AuthorizationService";
import LeadPartyApi from "../../service/LeadPartyService";
import PreferenceApi from "../../service/PreferenceService";

import AssignInitiatorToLeadPartyRequest from "../../service/request/AssignInitiatorToLeadPartyRequest";
import CompleteTaskRequest from "../../service/request/CompleteTaskRequest";
import TaskApi from "../../service/TaskService";

export default {
  name: "AssignToInitiatorDialog",
  props: {
    processId: {
      type: String,
      required: true
    },
    taskId: {
      type: String,
      required: true
    }
  },
  mixins: [],
  data: function() {
    return {
      userList: [],
      isRetrievingInitiatorList: false,
      selectedUnitCode: null,
      unitCodeItems: [],
      initiatorItems: [],
      selectedInitiatorId: 0,
      isAssignmentInProgress: false
    };
  },
  watch: {
    selectedUnitCode: function(newValue, oldValue) {
      this.retrieveInitiatorList();
    }
  },
  created() {
    this.SHOW = true;
  },
  beforeMount: async function() {
    this.isRetrievingInitiatorList = true;
    this.userList = await this.getUsers();
    this.userList.sort(function(a, b) {
      return a.fullName.localeCompare(b.fullName);
    });
    this.unitCodeItems = await this.retrieveEligibleProfiles();
    if (this.unitCodeItems != null && this.unitCodeItems.length > 0) {
      this.selectedUnitCode = this.unitCodeItems[0].name;
    }
    this.retrieveInitiatorList();
    this.isRetrievingInitiatorList = false;
  },
  methods: {
    getUsers: function() {
      return new Promise(resolve => {
        AuthorizationApi.getUsers(
          this,
          response => {
            if (response != null && response.resultList != null) {
              resolve(
                response.resultList.filter(
                  user => user.domainId == this.$store.getters["user"].domainId
                )
              );
            }
            resolve([]);
          },
          error => {
            resolve([]);
          }
        );
      });
    },
    retrieveInitiatorList() {
      this.initiatorItems = [];
      this.userList.forEach(user => {
        if (
          this.selectedUnitCode != null &&
          user.profile == this.selectedUnitCode
        ) {
          this.initiatorItems.push({
            fullName:
              user.unitCode != "001"
                ? user.fullName + " - " + user.unitType
                : user.fullName,
            id: user.id,
            unitCode: user.unitCode
          });
        }
      });
    },
    onClickCancel() {
      this.close();
    },
    retrieveEligibleProfiles() {
      return new Promise(resolve => {
        PreferenceApi.getAllByMnemonic(
          this,
          "assignToInitiatorProfiles",
          response => {
            if (response && response.result) {
              resolve(response.result);
            }
          },
          error => {
            console.log(error, "getAllByMnemonic error");
            resolve([]);
          }
        );
      });
    },

    completeTask(taskId) {
      return new Promise(resolve => {
        const completeTaskRequest = new CompleteTaskRequest();
        completeTaskRequest.taskId = taskId;

        TaskApi.completeTask(
          this,
          completeTaskRequest,
          () => {
            resolve();
          },
          error => {
            console.error(error);
            resolve();
          }
        );
      });
    },

    onClickAssignToInitiator(id,taskId) {
      this.isAssignmentInProgress = true;

      const selectedInitiator = this.initiatorItems.find(
        initiator => initiator.id === this.selectedInitiatorId
      );

      const completeTaskRequest = new CompleteTaskRequest();
      completeTaskRequest.taskId = this.taskId;
      completeTaskRequest.variables = [
        {
          code: "assignedUserId",
          value: selectedInitiator.id
        }
      ];

      TaskApi.completeTask(
        this,
        completeTaskRequest,
        () => {
          this.isAssignmentInProgress = false;
          this.close();
        },
        error => {
          console.log(error);
          this.isAssignmentInProgress = false;
        }
      );

    },
    close() {
      this.$emit("onCloseAssignToInitiatorDialog");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/mixin/AssignToInitiatorDialog.js